import styled from 'styled-components';

export const Icon = styled.span`
  display: inline-block;
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;

  svg {
    height: ${({ height }) => height}px;
    width: ${({ width }) => width}px;
  }
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/Icon.js